export class DialogConfig<D = unknown> {
  title: string;
  style: string;
  closeOnNavigation?: boolean;
  overPanel?: boolean;
  data?: D;
}
